
































































    import { LocaleMixin } from '@/locales/locale-mixin';
    import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
    import { ReportMappingObject, ReportParameters } from '@/reports/models/reports';
    import { ReportDateFiltersService } from '@/reports/report-date-filters-service';
    import { SelectListOption } from '@/core/models/select-list';
    import { ReportIdentifier } from '@/reports/report-constants';
    import { EventTypes } from '@/constants/event-type-constants';
    import { Report } from 'flexmonster';
    import { getDateParametersFromSavedReport } from '@/reports/report-utils';
    import { getModule } from 'vuex-module-decorators';
    import { InterfaceSettingsStore } from '@/dashboards/store/interface-settings-store';
    import { ReportFilterUtils } from '@/reports/utils/report-filter-utils';

    const reportDateFilterService = new ReportDateFiltersService();
    const settingsState = getModule(InterfaceSettingsStore);

@Component
    export default class ReportDateFilter extends Mixins(LocaleMixin) {
        @Prop({ required: true }) mappingObject!: ReportMappingObject;
        @Prop({ required: true }) activeReport!: ReportIdentifier;
        @Prop() readonly savedReport!: Report | null;

        private inputEvent = EventTypes.INPUT;
        private isLoaded = false;
        private reportParameters: ReportParameters = this.getInitialReportParameters();

        get items(): Array<SelectListOption> {
            return reportDateFilterService.getDateFiltersAsListItems(this.mappingObject);
        }

        private getInitialReportParameters(): ReportParameters {
            return ReportFilterUtils.getInitialReportParameters(
                this.preFilterReportsEnabled,
                this.activeReport
            );
        }

        updateFilters() {
            this.$emit(EventTypes.REPORT_DATE_FILTER_UPDATED, this.reportParameters);
        }

        async created() {
            await settingsState.init();
        }

        @Watch('preFilterReportsEnabled')
        private onPreFilterSettingChanged(newValue: boolean) {
            if (!this.savedReport) {
                this.updateParametersBasedOnSetting(newValue);
            }
        }

        get preFilterReportsEnabled(): boolean {
            return settingsState.preFilterReports;
        }

        private updateParametersBasedOnSetting(enabled: boolean): void {
            this.reportParameters = ReportFilterUtils.updateParametersBasedOnSetting(
                enabled,
                this.activeReport
            );

            this.$emit(EventTypes.REPORT_DATE_FILTER_UPDATED, this.reportParameters);
        }

        mounted() {
            if (this.savedReport) {
                this.reportParameters = getDateParametersFromSavedReport(this.savedReport);
                this.$emit(EventTypes.REPORT_DATE_FILTER_UPDATED, this.reportParameters);
                this.isLoaded = true;
                return;
            }
            this.updateParametersBasedOnSetting(this.preFilterReportsEnabled);
            this.isLoaded = true;
        }
    }
